export default "__VITE_ASSET__Bq6lYNrl__"